import type { ThemeProviderRef } from '@halo/ui-react';
import { ThemeProvider } from '@halo/ui-react';
import { Toaster } from '@halo/ui-chat-react';
import routerRoot from './scripts/router';
import { I18nProvider } from './store/i18n';
import { useSettingsStore } from './store/settings';

export function Root() {
  const refThemeProvider = useRef<ThemeProviderRef>(null);
  const { fontSize, normal } = useSettingsStore();

  useLayoutEffect(() => {
    refThemeProvider.current?.value.setScale(fontSize - normal);
  }, [fontSize, normal]);

  return (
    <I18nProvider>
      <ThemeProvider ref={refThemeProvider} themeProps={{ overflow: 'hidden' }}>
        <Toaster />
        {routerRoot}
      </ThemeProvider>
    </I18nProvider>
  );
}
